import { useLanguage } from '../../context/language-context-provider';
const EcommerceStatistics = () => {
  const {
    t
  } = useLanguage();
  return <div className='flex flex-col items-center justify-center gap-6 py-5.5 lg:flex-row-reverse lg:py-6' data-sentry-component="EcommerceStatistics" data-sentry-source-file="ecommerce.tsx">
            <div className='item'>
                <span className='title'>{t('statistics.ecommerce.item1.title')}</span>
                <span className='value'>{t('statistics.ecommerce.item1.text')}</span>
            </div>
            <div className='item'>
                <span className='title'>{t('statistics.ecommerce.item2.title')}</span>
                <span className='value'>{t('statistics.ecommerce.item2.text')}</span>
            </div>
            <div className='item'>
                <span className='title'>{t('statistics.ecommerce.item3.title')}</span>
                <span className='value'>{t('statistics.ecommerce.item3.text')}</span>
            </div>
            <div className='item'>
                <span className='title'>{t('statistics.ecommerce.item4.title')}</span>
                <span className='value'>{t('statistics.ecommerce.item4.text')}</span>
            </div>
        </div>;
};
export default EcommerceStatistics;